import React from 'react';
import { BsSend } from 'react-icons/bs';
import { GiPaperClip } from 'react-icons/gi';

const MessageInput = ({
  message,
  setMessage,
  file,
  setFile,
  fileInputRef,
  handleFileChange,
  handleSendReply,
  uploading,
}) => {
  return (
    <>
      {/* File Preview */}
      {file && (
        <div className="flex justify-center p-2 bg-gray-50 border-b border-gray-200">
          <div className="flex items-center gap-2 text-sm text-gray-600 bg-white rounded-lg px-3 py-2 border border-gray-200">
            <GiPaperClip className="w-4 h-4 shrink-0" />
            <span className="max-w-xs truncate">{file.name}</span>
            <button
              onClick={() => {
                setFile(null);
                if (fileInputRef.current) {
                  fileInputRef.current.value = '';
                }
              }}
              className="text-red-500 hover:text-red-700 font-bold leading-none">
              ×
            </button>
          </div>
        </div>
      )}
  
      {/* Message Input */}
      <div className="border-t border-gray-200 p-4">
        <div className="flex items-center gap-2 bg-white rounded-lg border border-gray-200">
          {/* Input */}
          <input
            type="text"
            placeholder="Write message"
            className="flex-1 h-10 px-3 outline-none text-sm font-light"
            value={message}
            onChange={e => setMessage(e.target.value)}
            onKeyDown={e => {
              if (e.key === 'Enter') {
                handleSendReply();
              }
            }}
          />
  
          {/* Actions */}
          <div className="flex items-center gap-1">
            <input
              type="file"
              ref={fileInputRef}
              onChange={handleFileChange}
              className="hidden"
              id="file-upload"
            />
  
            <button
              type="button"
              className="h-10 w-10 flex items-center justify-center hover:bg-gray-100 rounded-full"
              onClick={() => document.getElementById('file-upload').click()}
            >
              <GiPaperClip className="w-5 h-5 text-gray-500" />
            </button>
  
            <button
              type="button"
              className="h-10 px-4 bg-black text-white rounded-lg flex items-center gap-2"
              onClick={handleSendReply}
              disabled={uploading}
            >
              {uploading ? (
                <span className="text-sm font-light">Uploading...</span>
              ) : (
                <>
                  <span className="text-sm font-light">Send</span>
                  <BsSend className="w-4 h-4" />
                </>
              )}
            </button>
          </div>
        </div>
      </div>
    </>
  );
  
};

export default MessageInput;
